(() => {
  const root = document.querySelector('[data-hmm]');
  if (!root) return;

  const wrap = root.querySelector('[data-hmm-tab]');
  const panel = root.querySelector('.hmm__panel');
  const button = root.querySelector('.hmm__tab');

  if (!wrap || !panel || !button) return;

  const col1Items = panel.querySelectorAll('[data-hmm-item1]');
  const col2 = panel.querySelector('[data-hmm-col2]');
  const col3 = panel.querySelector('[data-hmm-col3]');
  const col2Title = panel.querySelector('[data-hmm-col2-title]');
  const col3Title = panel.querySelector('[data-hmm-col3-title]');

  const buildFromItem = (item) => {
    if (!item) return;

    col1Items.forEach(x => x.classList.remove('is-active'));
    item.classList.add('is-active');

    col2.innerHTML = '';
    col3.innerHTML = '';
    col2Title.textContent = item.querySelector('.hmm__label')?.textContent?.trim() || '';
    col3Title.textContent = '';

    const hidden = item.querySelector('.hmm__childData ul');
    if (!hidden) return;

    [...hidden.children].forEach((li) => {
      const a = li.querySelector(':scope > a');
      if (!a) return;

      const li2 = document.createElement('li');
      li2.innerHTML = `<a class="hmm__link" href="${a.getAttribute('href')}">${a.textContent.trim()}</a>`;
      col2.appendChild(li2);

      li2.addEventListener('mouseenter', () => {
        [...col2.children].forEach(x => x.classList.remove('is-active'));
        li2.classList.add('is-active');

        col3.innerHTML = '';
        col3Title.textContent = a.textContent.trim();

        const sub = li.querySelector(':scope > ul');
        if (!sub) return;

        [...sub.children].forEach(li3 => {
          const a3 = li3.querySelector('a');
          if (!a3) return;

          const node = document.createElement('li');
          node.innerHTML = `<a class="hmm__link" href="${a3.getAttribute('href')}">${a3.textContent.trim()}</a>`;
          col3.appendChild(node);
        });
      });
    });

    // Trigger first middle item (if any)
    const firstCol2 = col2.querySelector('li');
    if (firstCol2) firstCol2.dispatchEvent(new Event('mouseenter'));
  };

  const openMenu = () => {
    wrap.dataset.hmmOpen = "true";
    button.setAttribute('aria-expanded', 'true');
    if (col1Items[0]) buildFromItem(col1Items[0]);
  };

  const closeMenu = () => {
    wrap.dataset.hmmOpen = "false";
    button.setAttribute('aria-expanded', 'false');
  };

  const toggleMenu = () => {
    const isOpen = wrap.dataset.hmmOpen === "true";
    if (isOpen) closeMenu();
    else openMenu();
  };

  // Hover open/close
  wrap.addEventListener('mouseenter', openMenu);
  wrap.addEventListener('mouseleave', closeMenu);

  // Click toggle (important for touchpads)
  button.addEventListener('click', (e) => {
    e.preventDefault();
    toggleMenu();
  });

  // Build on left column hover
  col1Items.forEach(i => i.addEventListener('mouseenter', () => buildFromItem(i)));

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) closeMenu();
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
})();
